import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    async downloadApk({ rootGetters }, dldata) {
      if (typeof window === 'undefined') return

      try {
        const token = rootGetters['userAccess/accessToken'] // ✅ Correct access
        const apiUrl = process.env.VUE_APP_API_SERVER + '/admin/downloadApp/' + dldata.appname

        const response = await axios.get(apiUrl, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
        })

        const blob = new Blob([response.data], {
          type: 'application/vnd.android.package-archive'
        })
        const downloadUrl = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = dldata.appname + '.apk'
        link.style.display = 'none'

        // ✅ Safer insertion
        document.body.appendChild(link)
        setTimeout(() => {
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 0) // Delay for some browsers to handle render tree
      } catch (error) {
        console.error('Download failed:', error)
      }
    }
  }
}
